import { expandBorderRadii, paddingUtil } from "@gadgetinc/widgets";
import { useStyletron } from "baseui";
import { LabelLarge, ParagraphXSmall } from "baseui/typography";
import { observer } from "mobx-react-lite";
import React, { useEffect, useRef } from "react";
import { SeparateChildren } from "web/src/components/edit/shared/SeparateChildren";
import type { DocsSearchState, SearchResultHit } from "./DocsSearchState";
import { searchResultHitCategories, searchResultHitHighlights, searchResultHitTitle } from "./DocsSearchState";

export const SearchResult = observer((props: { state: DocsSearchState; result: SearchResultHit }) => {
  const [css, $theme] = useStyletron();
  const ref = useRef<HTMLDivElement>(null);
  const highlights = searchResultHitHighlights(props.result.hit);

  const isActive = props.state.activeResult == props.result;

  const categories = searchResultHitCategories(props.result.hit);
  const title = searchResultHitTitle(props.result.hit);

  useEffect(() => {
    if (isActive && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [isActive]);

  return (
    <a href={props.result.hit.url} style={{ textDecoration: "none", color: "inherit" }}>
      <div
        ref={ref}
        className={css({
          ...paddingUtil($theme.sizing.scale300, $theme.sizing.scale500),
          cursor: "pointer",
          ...expandBorderRadii($theme.borders.radius200),
          backgroundColor: isActive ? $theme.colors.primary100 : "transparent",
        })}
        onMouseEnter={() => props.state.setActivePosition(props.result.position)}
        tabIndex={0}
      >
        <LabelLarge>
          <span dangerouslySetInnerHTML={{ __html: title ?? "" }} />
        </LabelLarge>
        {highlights.category2 && (
          <ParagraphXSmall className={css({ marginBottom: $theme.sizing.scale200, color: $theme.colors.contentSecondary })}>
            <SeparateChildren separator=" > ">
              {categories.map((content, index) => (
                <span key={index} dangerouslySetInnerHTML={{ __html: content }} />
              ))}
            </SeparateChildren>
          </ParagraphXSmall>
        )}
        {highlights.content && (
          <ParagraphXSmall>
            <span dangerouslySetInnerHTML={{ __html: highlights.content.value }} />
          </ParagraphXSmall>
        )}
      </div>
    </a>
  );
});
